import { render, staticRenderFns } from "./scoped-form.vue?vue&type=template&id=584b525c"
import script from "./scoped-form.vue?vue&type=script&lang=js"
export * from "./scoped-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports